var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.64,
    height: 22.314,
    viewBox: "0 0 23.64 22.314",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-822.422-574.884a2.715,2.715,0,0,1,3.242-2.1c1.465.422,2.67,1.727,3.631,3.859,5.39-7.49,10.026-12.643,16.146-14.576.546-.128.833-.1.435.354-6.325,5.112-12.044,12.526-16.489,21.743a.352.352,0,0,1-.6-.035c-1.358-2.465-2.323-4.87-3.682-7.335-.606-1.274-1.373-2.192-2.684-1.906Z",
    transform: "translate(822.422 587.771)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9c3b8742cdeea5580e70d165104b2157.svg";
export { ForwardRef as ReactComponent };